export const RESET_TARIFF_LEGS = 'RESET_TARIFF_LEGS'
export const SET_TARIFF_LEGS = 'SET_TARIFF_LEGS'
export const RESET_TARIFFS = 'RESET_TARIFFS'
export const SET_TARIFFS = 'SET_TARIFFS'
